import { combineReducers } from "redux";
import { handleActions } from "redux-actions";
import { fetchActions, IFetchStoreState, initialFetchState, updateActions } from "reducers/base-reducers";
import { POS } from "constants/action-types";
import { IPOSStatus } from "constants/order-types";

export interface IPosState {
    status: IFetchStoreState<IPosStatusMap>;
}

export interface IPosStatusMap {
    [id: string]: IPOSStatus;
}

export const pos = combineReducers<IPosState>({
    status: handleActions<IPosState["status"]>(
        {
            ...fetchActions<IPosStatusMap>(POS.STATUS.FETCH),
            ...updateActions<IPosStatusMap>(POS.STATUS),
        } as any,
        initialFetchState,
    ),
});
